import settings from 'settings'
import get from 'lodash/get'

const accountId = get(window, '__PRELOADED_STATE__.currentAccount.id', 1)

// Equals true when ip is local
export const isInsider = get(settings, 'common.isInsider', false)
// const isEven = accountId % 2 === 0
//
// // Is ClanRec service up
// const _clanRecIsEnabled = get(settings, 'recommendations.isEnabled', false)
//
// // Is ClanRec 2 service up
// const _disableForNonInsiders = get(settings, 'clanrec2.disableForNonInsiders', true)
// const _clanRec2IsEnabled = get(settings, 'clanrec2.isEnabled', false)
//
// // ClanRec 2 is enabled when `ClanRec 2 service is up` and (
// //                       `client is insider` or (
// //                          `account spa id is even` and
// //                          `enabled for non insiders`
// //                          )
// //                       )
// export const ClanRec2IsEnabled = _clanRec2IsEnabled && (
//     isInsider || (isEven && !_disableForNonInsiders)
// )
//
// // ClanRec is enabled when `ClanRec service is up` and (
// //                      `client is insider` or
// //                      `account spa id is not even` or
// //                      `ClanRec 2 service is not enabled`
// //                      )
// export const ClanRecIsEnabled = _clanRecIsEnabled && (isInsider || !isEven || !ClanRec2IsEnabled)
//
// // ClanRec settings is enabled when `ClanRec service is up`
// export const ClanRecSettingsIsEnabled = _clanRecIsEnabled
//
// // ClanRec 2 settings is enabled when `ClanRec 2 service is up` and `client is insider`
// export const ClanRec2SettingsIsEnabled = _clanRec2IsEnabled && isInsider

export const ClanRec2IsEnabled = get(settings, 'clanrec2.isEnabled', false)
export const ClanRec2SettingsIsEnabled = ClanRec2IsEnabled

export const ClanRecIsEnabled = false
export const ClanRecSettingsIsEnabled = ClanRecIsEnabled

export const anyClanRecIsEnabled = ClanRec2IsEnabled || ClanRecIsEnabled

export const darwinIsEnabled = get(settings, 'darwin.isEnabled', false)
